<script lang="ts">
  export let level: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' = 'h1';
  export let align: 'left' | 'center' | 'right' = 'center';
  export let animate = false;
</script>

<div class="title-container">
  <div class="title" style="text-align: {align}">
    {#if level === 'h1'}
      <h1 class:animate><slot /></h1>
    {:else if level === 'h2'}
      <h2 class:animate><slot /></h2>
    {:else if level === 'h3'}
      <h3 class:animate><slot /></h3>
    {:else if level === 'h4'}
      <h4 class:animate><slot /></h4>
    {:else if level === 'h5'}
      <h5 class:animate><slot /></h5>
    {:else if level === 'h6'}
      <h6 class:animate><slot /></h6>
    {/if}
  </div>
</div>

<style lang="postcss">
  .title-container {
    container-type: inline-size;
    color: var(--text-color);

    h1 {
      font-size: 1.35rem;
    }

    h2 {
      font-size: 1.5rem;
    }

    h3 {
      font-size: 1.25rem;
    }

    h4 {
      font-size: 1.125rem;
    }

    h5 {
      font-size: 1rem;
    }

    h6 {
      font-size: 0.875rem;
    }

  }

  :global(.title-container) {
    font-weight: 600;
    line-height: 1.1;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
    font-weight: 600;
    line-height: 1.1;
  }


  /* Container queries for responsive font sizes */
  @container (max-width: 280px) {
    h1 {
      font-size: 1.125rem;
    }

    h2 {
      font-size: 1.025rem;
    }

    h3 {
      font-size: 0.925rem;
    }
  }

  @container (min-width: 281px) and (max-width: 420px) {
    h1 {
      font-size: 1.5rem;
    }

    h2 {
      font-size: 1.25rem;
    }

    h3 {
      font-size: 1.125rem;
    }
  }
</style>
